import correct from '@/assets/img/documents/house-hold/kosztorys.jpg';
import wrong from '@/assets/img/documents/house-hold/kosztorys-wrong.jpg';

import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const INSURERS_ESTIMATE_NAME = 'insurers_estimate';

const InsurersEstimate = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać kosztorys ubezpieczyciela?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane nieruchomości są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony kosztorysu.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Kosztorys ubezpieczyciela')}
        instructionProps={instructionProps}
        inputFieldName={INSURERS_ESTIMATE_NAME}
        attachmentTypeId={ATTACHMENT_TYPES.KOSZTORYS}
        data-testid={`${INSURERS_ESTIMATE_NAME}-uploader`}
      />
    </Card>
  );
};

export default InsurersEstimate;
